import { ReactElement } from 'react'
import {
  PageWrapper,
  SectionTitle,
  FlexWrapper,
  DropdownWrapper,
  EditableDropdown,
  Input,
  FileUploader
} from '../../../components'
import strings from '../../../locale/en'

const AddQuestion = (): ReactElement => {
  const {
    menu: {
      admin: {
        addQuestion,
        selectCourse,
        courseName,
        selectSubject,
        subjectName,
        selectChapter,
        chapterName,
        selectClass,
        className,
        selectLevel,
        questionType,
        selectQuestion,
        topicName
      }
    },
    test: { difficultyLevel }
  } = strings

  return (
    <PageWrapper id="container">
      <SectionTitle title={addQuestion} hasBorder />
      <FlexWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            title={courseName}
            isRequired
            placeholder={selectCourse}
            onBlur={() => {}}
            error={''}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            title={subjectName}
            isRequired
            placeholder={selectSubject}
            onBlur={() => {}}
            error={''}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            title={chapterName}
            isRequired
            placeholder={selectChapter}
            onBlur={() => {}}
            error={''}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
        <Input
          label={topicName}
          isRequired
          placeholder={topicName}
          value=""
          width="24%"
          name="topicName"
          onBlur={() => {}}
          error={''}
          onChange={() => {}}
          hasPadding={false}
        />
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            title={className}
            isRequired
            placeholder={selectClass}
            onBlur={() => {}}
            error={''}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            title={difficultyLevel}
            isRequired
            placeholder={selectLevel}
            onBlur={() => {}}
            error={''}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={[]}
            title={questionType}
            isRequired
            placeholder={selectQuestion}
            onBlur={() => {}}
            error={''}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
      </FlexWrapper>
      <FileUploader
        onUploadSuccess={(file) => {
          console.log(file)
        }}
      />
    </PageWrapper>
  )
}

export default AddQuestion
